/* ============================================================
   CARINA — newsletter.js
   Newsletter-Formular-Feedback
   ============================================================ */

'use strict';

class NewsletterForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.successMsg = this.querySelector('[data-success]');
    this.errorMsg = this.querySelector('[data-error]');
    this.input = this.querySelector('input[type="email"]');
    this.submitBtn = this.querySelector('[type="submit"]');

    if (!this.form) return;

    // Shopify sets ?customer_posted=true on success
    const params = new URLSearchParams(window.location.search);
    if (params.get('customer_posted') === 'true') {
      this._showSuccess();
    }
  }

  _showSuccess() {
    if (this.form) this.form.setAttribute('hidden', '');
    if (this.successMsg) this.successMsg.removeAttribute('hidden');
    if (this.successMsg) {
      this.successMsg.setAttribute('role', 'alert');
      this.successMsg.focus();
    }
  }
}

if (!customElements.get('newsletter-form')) {
  customElements.define('newsletter-form', NewsletterForm);
}
